{
  "en": {
    "C в минуту": "C per minute",
    "MP4 или MOV": "MP4 or MOV",
    "{0} повторил движения из видео, {1}.": "{0} repeated the movements from the video, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} repeated the movements from the video, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} is now in your video: the movements and facial expressions are yours, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} is now in your video: the movements and facial expressions are yours.",
    "Бот уже прислал видео в чат, в отдельную тему.": "The bot has already sent the video to the chat, in a separate topic.",
    "В видео не видно человека": "No person is visible in the video",
    "В видео нет звука: менять голос нечего": "The video has no sound: there is no voice to change",
    "Видео и фото проверены": "Video and photo checked",
    "Видео или фото не прошли проверку": "The video or photo did not pass the check",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "The video is shorter than {0} seconds: it must be {0} to {1} seconds long",
    "Видео короче нужного, загрузите другое": "The video is too short, upload another one",
    "Вы повторили движения из видео, {0}.": "You repeated the movements from the video, {0}.",
    "Выберите фрагмент от 3 секунд": "Choose a clip of at least 3 seconds",
    "Выберите, кем стать": "Choose who to become",
    "Выберите, кто повторит": "Choose who will repeat it",
    "Герой": "The character",
    "Голос героя": "Character’s voice",
    "Двигайте фото: в кадре лицо и тело": "Move the photo: keep the face and body in the frame",
    "Движения перенесены": "Movements transferred",
    "Движения прочитаны": "Movements read",
    "Добавьте свои фото или выберите вариант": "Add your photos or choose a variant",
    "Добавьте фото того, кто повторит": "Add a photo of the person who will repeat it",
    "Другое фото": "Another photo",
    "Загрузите видео с собой": "Upload a video of yourself",
    "Загрузите фото того, кто повторит": "Upload a photo of the person who will repeat it",
    "Закончите кадр фото": "Finish framing the photo",
    "Заменить видео или фото": "Replace the video or photo",
    "Кем вы станете в видео": "Who you will become in the video",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "A video bubble from this video is not available yet: the result has no confirmed audio track.",
    "Можно своё фото: только своё или с согласием человека на нём": "You can use a photo: only your own or with the consent of the person in it",
    "Нажмите на фото ещё раз: кадр или другое фото": "Tap the photo again: framing or another photo",
    "Не нашли человека: нужен один человек в полный рост": "No person found: one full-length person is needed",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "No person found: one person from the waist up or full-length is needed",
    "Нужно фото: {0}": "A photo is needed: {0}",
    "Осталось выбрать, кем стать": "Now choose who to become",
    "Осталось выбрать, кто повторит": "Now choose who will repeat it",
    "Осталось добавить фото: {0}": "Now add photos: {0}",
    "Переносим движения": "Transferring the movements",
    "По пояс или в полный рост, от {0} до {1} секунд": "From the waist up or full-length, {0} to {1} seconds",
    "Права и согласие": "Rights and consent",
    "Проверяем видео и фото": "Checking the video and photo",
    "Смотреть": "Watch",
    "Смотреть видео с движениями": "Watch the motion video",
    "Сначала выберите, кто повторит": "First choose who will repeat it",
    "Снимите движения: один человек в полный рост": "Film the movements: one full-length person",
    "Снимите себя по пояс или в полный рост": "Film yourself from the waist up or full-length",
    "Создать · {0} C": "Create · {0} C",
    "Создать · от {0} C": "Create · from {0} C",
    "Сцена вашего видео, герой встанет на место человека": "The scene of your video, the character takes the person’s place",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "A dance or trend, one full-length person, {0} to {1} seconds",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "“You” has no voice of its own: clone it in the “Clone” section or choose another one",
    "У героя нет своего голоса": "The character has no voice of its own",
    "У человека с фото нет своего голоса: выберите другой голос": "The person from the photo has no voice of their own: choose another voice",
    "Удалить из видео": "Remove from the video",
    "Файл слишком большой. Максимум {0} МБ": "The file is too large. Maximum {0} MB",
    "Фон с вашего фото": "Background from your photo",
    "Фон с картинки персонажа": "Background from the character’s picture",
    "Фон с фото близкого": "Background from the relative’s photo",
    "Фон со снимка героя": "Background from the character’s image",
    "Фрагмент короче {0} секунд: растяните окно": "The clip is shorter than {0} seconds: widen the window",
    "Человек в кадре": "Person in the frame",
    "Читаем движения": "Reading the movements",
    "Чужие фото без согласия и запрещённое не пропускаем.": "We don’t accept other people’s photos without consent or prohibited content.",
    "видео {0}": "video {0}",
    "голос «{0}»": "voice “{0}”",
    "голос «{0}», формат тот же": "voice “{0}”, same format",
    "до": "up to",
    "звук и формат те же": "same sound and format",
    "звук как в видео": "sound as in the video",
    "из видео": "from the video",
    "из длинного выберете {0} секунд": "from a longer one you’ll choose {0} seconds",
    "из этого видео": "from this video",
    "не повторит движения: нужен человек": "can’t repeat the movements: a person is needed",
    "фон с героя": "background from the character",
    "формат тот же": "same format"
  },
  "hy": {
    "C в минуту": "C մեկ րոպեում",
    "MP4 или MOV": "MP4 կամ MOV",
    "{0} повторил движения из видео, {1}.": "{0} կրկնեց տեսանյութի շարժումները, {1}։",
    "{0} повторила движения из видео, {1}.": "{0} կրկնեց տեսանյութի շարժումները, {1}։",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} այժմ ձեր տեսանյութում է․ շարժումներն ու դիմախաղը ձերն են, {1}։",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} այժմ ձեր տեսանյութում է․ շարժումներն ու դիմախաղը ձերն են։",
    "Бот уже прислал видео в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է տեսանյութը չաթ՝ առանձին թեմայում։",
    "В видео не видно человека": "Տեսանյութում մարդ չի երևում",
    "В видео нет звука: менять голос нечего": "Տեսանյութում ձայն չկա․ փոխելու ձայն չկա",
    "Видео и фото проверены": "Տեսանյութը և լուսանկարը ստուգված են",
    "Видео или фото не прошли проверку": "Տեսանյութը կամ լուսանկարը չանցան ստուգումը",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "Տեսանյութը {0} վայրկյանից կարճ է․ պետք է լինի {0}-ից {1} վայրկյան",
    "Видео короче нужного, загрузите другое": "Տեսանյութը շատ կարճ է, վերբեռնեք մեկ ուրիշը",
    "Вы повторили движения из видео, {0}.": "Դուք կրկնեցիք տեսանյութի շարժումները, {0}։",
    "Выберите фрагмент от 3 секунд": "Ընտրեք առնվազն 3 վայրկյան հատված",
    "Выберите, кем стать": "Ընտրեք, թե ով դառնալ",
    "Выберите, кто повторит": "Ընտրեք, թե ով կկրկնի",
    "Герой": "Հերոսը",
    "Голос героя": "Հերոսի ձայնը",
    "Двигайте фото: в кадре лицо и тело": "Շարժեք լուսանկարը․ կադրում՝ դեմքն ու մարմինը",
    "Движения перенесены": "Շարժումները փոխանցված են",
    "Движения прочитаны": "Շարժումները կարդացված են",
    "Добавьте свои фото или выберите вариант": "Ավելացրեք ձեր լուսանկարները կամ ընտրեք տարբերակ",
    "Добавьте фото того, кто повторит": "Ավելացրեք նրա լուսանկարը, ով կկրկնի",
    "Другое фото": "Այլ լուսանկար",
    "Загрузите видео с собой": "Վերբեռնեք տեսանյութ ձեր մասնակցությամբ",
    "Загрузите фото того, кто повторит": "Վերբեռնեք նրա լուսանկարը, ով կկրկնի",
    "Закончите кадр фото": "Ավարտեք լուսանկարի կադրը",
    "Заменить видео или фото": "Փոխարինել տեսանյութը կամ լուսանկարը",
    "Кем вы станете в видео": "Ով կդառնաք տեսանյութում",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "Այս տեսանյութից խոսող շրջանիկը դեռ հասանելի չէ․ արդյունքում հաստատված ձայնային ուղի չկա։",
    "Можно своё фото: только своё или с согласием человека на нём": "Կարելի է լուսանկար․ միայն ձերը կամ դրանում պատկերված անձի համաձայնությամբ",
    "Нажмите на фото ещё раз: кадр или другое фото": "Կրկին սեղմեք լուսանկարին․ կադր կամ այլ լուսանկար",
    "Не нашли человека: нужен один человек в полный рост": "Մարդ չգտանք․ անհրաժեշտ է մեկ մարդ ամբողջ հասակով",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Մարդ չգտանք․ անհրաժեշտ է մեկ մարդ մինչև գոտկատեղ կամ ամբողջ հասակով",
    "Нужно фото: {0}": "Անհրաժեշտ է լուսանկար՝ {0}",
    "Осталось выбрать, кем стать": "Մնում է ընտրել, թե ով դառնալ",
    "Осталось выбрать, кто повторит": "Մնում է ընտրել, թե ով կկրկնի",
    "Осталось добавить фото: {0}": "Մնում է ավելացնել լուսանկարներ՝ {0}",
    "Переносим движения": "Փոխանցում ենք շարժումները",
    "По пояс или в полный рост, от {0} до {1} секунд": "Մինչև գոտկատեղ կամ ամբողջ հասակով, {0}-ից {1} վայրկյան",
    "Права и согласие": "Իրավունքներ և համաձայնություն",
    "Проверяем видео и фото": "Ստուգում ենք տեսանյութը և լուսանկարը",
    "Смотреть": "Դիտել",
    "Смотреть видео с движениями": "Դիտել շարժումների տեսանյութը",
    "Сначала выберите, кто повторит": "Նախ ընտրեք, թե ով կկրկնի",
    "Снимите движения: один человек в полный рост": "Նկարահանեք շարժումները․ մեկ մարդ ամբողջ հասակով",
    "Снимите себя по пояс или в полный рост": "Նկարահանեք ձեզ մինչև գոտկատեղ կամ ամբողջ հասակով",
    "Создать · {0} C": "Ստեղծել · {0} C",
    "Создать · от {0} C": "Ստեղծել · {0} C-ից",
    "Сцена вашего видео, герой встанет на место человека": "Ձեր տեսանյութի տեսարանը, հերոսը կզբաղեցնի մարդու տեղը",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Պար կամ թրենդ, մեկ մարդ ամբողջ հասակով, {0}-ից {1} վայրկյան",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "«Դուք»-ը սեփական ձայն չունի․ կլոնավորեք այն «Կլոն» բաժնում կամ ընտրեք այլ ձայն",
    "У героя нет своего голоса": "Հերոսը սեփական ձայն չունի",
    "У человека с фото нет своего голоса: выберите другой голос": "Լուսանկարի մարդը սեփական ձայն չունի․ ընտրեք այլ ձայն",
    "Удалить из видео": "Հեռացնել տեսանյութից",
    "Файл слишком большой. Максимум {0} МБ": "Ֆայլը չափազանց մեծ է։ Առավելագույնը՝ {0} ՄԲ",
    "Фон с вашего фото": "Ֆոնը՝ ձեր լուսանկարից",
    "Фон с картинки персонажа": "Ֆոնը՝ կերպարի նկարից",
    "Фон с фото близкого": "Ֆոնը՝ հարազատի լուսանկարից",
    "Фон со снимка героя": "Ֆոնը՝ հերոսի նկարից",
    "Фрагмент короче {0} секунд: растяните окно": "Հատվածը {0} վայրկյանից կարճ է․ ընդլայնեք պատուհանը",
    "Человек в кадре": "Մարդը կադրում է",
    "Читаем движения": "Կարդում ենք շարժումները",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Ուրիշների լուսանկարներն առանց համաձայնության և արգելված բովանդակությունը չենք ընդունում։",
    "видео {0}": "տեսանյութ {0}",
    "голос «{0}»": "«{0}» ձայն",
    "голос «{0}», формат тот же": "«{0}» ձայն, ձևաչափը նույնն է",
    "до": "մինչև",
    "звук и формат те же": "ձայնը և ձևաչափը նույնն են",
    "звук как в видео": "ձայնը՝ ինչպես տեսանյութում",
    "из видео": "տեսանյութից",
    "из длинного выберете {0} секунд": "երկարից կընտրեք {0} վայրկյան",
    "из этого видео": "այս տեսանյութից",
    "не повторит движения: нужен человек": "չի կրկնի շարժումները․ անհրաժեշտ է մարդ",
    "фон с героя": "ֆոնը՝ հերոսից",
    "формат тот же": "ձևաչափը նույնն է"
  },
  "es": {
    "C в минуту": "C por minuto",
    "MP4 или MOV": "MP4 o MOV",
    "{0} повторил движения из видео, {1}.": "{0} repitió los movimientos del vídeo, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} repitió los movimientos del vídeo, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} ya está en tu vídeo: los movimientos y los gestos son tuyos, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} ya está en tu vídeo: los movimientos y los gestos son tuyos.",
    "Бот уже прислал видео в чат, в отдельную тему.": "El bot ya ha enviado el vídeo al chat, en un tema aparte.",
    "В видео не видно человека": "No se ve a ninguna persona en el vídeo",
    "В видео нет звука: менять голос нечего": "El vídeo no tiene sonido: no hay voz que cambiar",
    "Видео и фото проверены": "Vídeo y foto verificados",
    "Видео или фото не прошли проверку": "El vídeo o la foto no superaron la revisión",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "El vídeo dura menos de {0} segundos: debe durar de {0} a {1} segundos",
    "Видео короче нужного, загрузите другое": "El vídeo es demasiado corto, sube otro",
    "Вы повторили движения из видео, {0}.": "Repetiste los movimientos del vídeo, {0}.",
    "Выберите фрагмент от 3 секунд": "Elige un fragmento de al menos 3 segundos",
    "Выберите, кем стать": "Elige en quién convertirte",
    "Выберите, кто повторит": "Elige quién lo repetirá",
    "Герой": "El personaje",
    "Голос героя": "Voz del personaje",
    "Двигайте фото: в кадре лицо и тело": "Mueve la foto: que se vean la cara y el cuerpo",
    "Движения перенесены": "Movimientos transferidos",
    "Движения прочитаны": "Movimientos leídos",
    "Добавьте свои фото или выберите вариант": "Añade tus fotos o elige una variante",
    "Добавьте фото того, кто повторит": "Añade una foto de quien lo repetirá",
    "Другое фото": "Otra foto",
    "Загрузите видео с собой": "Sube un vídeo en el que salgas tú",
    "Загрузите фото того, кто повторит": "Sube una foto de quien lo repetirá",
    "Закончите кадр фото": "Termina el encuadre de la foto",
    "Заменить видео или фото": "Cambiar el vídeo o la foto",
    "Кем вы станете в видео": "En quién te convertirás en el vídeo",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "El vídeo circular de este vídeo aún no está disponible: el resultado no tiene una pista de audio confirmada.",
    "Можно своё фото: только своё или с согласием человека на нём": "Puedes usar una foto: solo tuya o con el consentimiento de la persona que aparece",
    "Нажмите на фото ещё раз: кадр или другое фото": "Toca la foto otra vez: encuadre u otra foto",
    "Не нашли человека: нужен один человек в полный рост": "No encontramos a nadie: se necesita una persona de cuerpo entero",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "No encontramos a nadie: se necesita una persona de medio cuerpo o de cuerpo entero",
    "Нужно фото: {0}": "Se necesita una foto: {0}",
    "Осталось выбрать, кем стать": "Solo falta elegir en quién convertirte",
    "Осталось выбрать, кто повторит": "Solo falta elegir quién lo repetirá",
    "Осталось добавить фото: {0}": "Solo falta añadir fotos: {0}",
    "Переносим движения": "Transfiriendo los movimientos",
    "По пояс или в полный рост, от {0} до {1} секунд": "De medio cuerpo o de cuerpo entero, de {0} a {1} segundos",
    "Права и согласие": "Derechos y consentimiento",
    "Проверяем видео и фото": "Comprobando el vídeo y la foto",
    "Смотреть": "Ver",
    "Смотреть видео с движениями": "Ver el vídeo de movimientos",
    "Сначала выберите, кто повторит": "Primero elige quién lo repetirá",
    "Снимите движения: один человек в полный рост": "Graba los movimientos: una persona de cuerpo entero",
    "Снимите себя по пояс или в полный рост": "Grábate de medio cuerpo o de cuerpo entero",
    "Создать · {0} C": "Crear · {0} C",
    "Создать · от {0} C": "Crear · desde {0} C",
    "Сцена вашего видео, герой встанет на место человека": "La escena de tu vídeo; el personaje ocupará el lugar de la persona",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Un baile o una tendencia, una persona de cuerpo entero, de {0} a {1} segundos",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "«Tú» no tiene voz propia: clónala en la sección «Clon» o elige otra",
    "У героя нет своего голоса": "El personaje no tiene voz propia",
    "У человека с фото нет своего голоса: выберите другой голос": "La persona de la foto no tiene voz propia: elige otra voz",
    "Удалить из видео": "Quitar del vídeo",
    "Файл слишком большой. Максимум {0} МБ": "El archivo es demasiado grande. Máximo {0} MB",
    "Фон с вашего фото": "Fondo de tu foto",
    "Фон с картинки персонажа": "Fondo de la imagen del personaje",
    "Фон с фото близкого": "Fondo de la foto de la persona cercana",
    "Фон со снимка героя": "Fondo de la imagen del personaje",
    "Фрагмент короче {0} секунд: растяните окно": "El fragmento dura menos de {0} segundos: amplía la ventana",
    "Человек в кадре": "Persona en el encuadre",
    "Читаем движения": "Leyendo los movimientos",
    "Чужие фото без согласия и запрещённое не пропускаем.": "No aceptamos fotos de otras personas sin su consentimiento ni contenido prohibido.",
    "видео {0}": "vídeo {0}",
    "голос «{0}»": "voz «{0}»",
    "голос «{0}», формат тот же": "voz «{0}», mismo formato",
    "до": "hasta",
    "звук и формат те же": "mismo sonido y formato",
    "звук как в видео": "sonido como en el vídeo",
    "из видео": "del vídeo",
    "из длинного выберете {0} секунд": "de uno más largo elegirás {0} segundos",
    "из этого видео": "de este vídeo",
    "не повторит движения: нужен человек": "no puede repetir los movimientos: se necesita una persona",
    "фон с героя": "fondo del personaje",
    "формат тот же": "mismo formato"
  },
  "de": {
    "C в минуту": "C pro Minute",
    "MP4 или MOV": "MP4 oder MOV",
    "{0} повторил движения из видео, {1}.": "{0} hat die Bewegungen aus dem Video nachgeahmt, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} hat die Bewegungen aus dem Video nachgeahmt, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} ist jetzt in Ihrem Video: Bewegungen und Mimik sind Ihre, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} ist jetzt in Ihrem Video: Bewegungen und Mimik sind Ihre.",
    "Бот уже прислал видео в чат, в отдельную тему.": "Der Bot hat das Video bereits in den Chat geschickt, in ein eigenes Thema.",
    "В видео не видно человека": "Im Video ist keine Person zu sehen",
    "В видео нет звука: менять голос нечего": "Das Video hat keinen Ton: Es gibt keine Stimme zum Ändern",
    "Видео и фото проверены": "Video und Foto geprüft",
    "Видео или фото не прошли проверку": "Video oder Foto hat die Prüfung nicht bestanden",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "Das Video ist kürzer als {0} Sekunden: Es muss {0} bis {1} Sekunden lang sein",
    "Видео короче нужного, загрузите другое": "Das Video ist zu kurz, laden Sie ein anderes hoch",
    "Вы повторили движения из видео, {0}.": "Sie haben die Bewegungen aus dem Video nachgeahmt, {0}.",
    "Выберите фрагмент от 3 секунд": "Wählen Sie einen Ausschnitt ab 3 Sekunden",
    "Выберите, кем стать": "Wählen Sie, wer Sie werden möchten",
    "Выберите, кто повторит": "Wählen Sie, wer es wiederholt",
    "Герой": "Die Figur",
    "Голос героя": "Stimme der Figur",
    "Двигайте фото: в кадре лицо и тело": "Verschieben Sie das Foto: Gesicht und Körper im Bild",
    "Движения перенесены": "Bewegungen übertragen",
    "Движения прочитаны": "Bewegungen erfasst",
    "Добавьте свои фото или выберите вариант": "Fügen Sie Ihre Fotos hinzu oder wählen Sie eine Variante",
    "Добавьте фото того, кто повторит": "Fügen Sie ein Foto der Person hinzu, die es wiederholt",
    "Другое фото": "Anderes Foto",
    "Загрузите видео с собой": "Laden Sie ein Video von sich hoch",
    "Загрузите фото того, кто повторит": "Laden Sie ein Foto der Person hoch, die es wiederholt",
    "Закончите кадр фото": "Schließen Sie den Bildausschnitt des Fotos ab",
    "Заменить видео или фото": "Video oder Foto ersetzen",
    "Кем вы станете в видео": "Wer Sie im Video werden",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "Ein rundes Video aus diesem Video ist noch nicht verfügbar: Das Ergebnis hat keine bestätigte Tonspur.",
    "Можно своё фото: только своё или с согласием человека на нём": "Ein eigenes Foto ist möglich: nur Ihr eigenes oder mit Einwilligung der abgebildeten Person",
    "Нажмите на фото ещё раз: кадр или другое фото": "Tippen Sie erneut auf das Foto: Bildausschnitt oder anderes Foto",
    "Не нашли человека: нужен один человек в полный рост": "Keine Person gefunden: Es wird eine Person in voller Größe benötigt",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Keine Person gefunden: Es wird eine Person ab der Hüfte oder in voller Größe benötigt",
    "Нужно фото: {0}": "Benötigt wird ein Foto: {0}",
    "Осталось выбрать, кем стать": "Jetzt noch wählen, wer Sie werden möchten",
    "Осталось выбрать, кто повторит": "Jetzt noch wählen, wer es wiederholt",
    "Осталось добавить фото: {0}": "Jetzt noch Fotos hinzufügen: {0}",
    "Переносим движения": "Bewegungen werden übertragen",
    "По пояс или в полный рост, от {0} до {1} секунд": "Ab der Hüfte oder in voller Größe, {0} bis {1} Sekunden",
    "Права и согласие": "Rechte und Einwilligung",
    "Проверяем видео и фото": "Video und Foto werden geprüft",
    "Смотреть": "Ansehen",
    "Смотреть видео с движениями": "Bewegungsvideo ansehen",
    "Сначала выберите, кто повторит": "Wählen Sie zuerst, wer es wiederholt",
    "Снимите движения: один человек в полный рост": "Filmen Sie die Bewegungen: eine Person in voller Größe",
    "Снимите себя по пояс или в полный рост": "Filmen Sie sich ab der Hüfte oder in voller Größe",
    "Создать · {0} C": "Erstellen · {0} C",
    "Создать · от {0} C": "Erstellen · ab {0} C",
    "Сцена вашего видео, герой встанет на место человека": "Die Szene Ihres Videos, die Figur nimmt den Platz der Person ein",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Ein Tanz oder Trend, eine Person in voller Größe, {0} bis {1} Sekunden",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "„Sie“ hat keine eigene Stimme: Klonen Sie sie im Bereich „Klon“ oder wählen Sie eine andere",
    "У героя нет своего голоса": "Die Figur hat keine eigene Stimme",
    "У человека с фото нет своего голоса: выберите другой голос": "Die Person vom Foto hat keine eigene Stimme: Wählen Sie eine andere Stimme",
    "Удалить из видео": "Aus dem Video entfernen",
    "Файл слишком большой. Максимум {0} МБ": "Die Datei ist zu groß. Maximal {0} MB",
    "Фон с вашего фото": "Hintergrund aus Ihrem Foto",
    "Фон с картинки персонажа": "Hintergrund aus dem Bild der Figur",
    "Фон с фото близкого": "Hintergrund aus dem Foto der angehörigen Person",
    "Фон со снимка героя": "Hintergrund aus dem Bild der Figur",
    "Фрагмент короче {0} секунд: растяните окно": "Der Ausschnitt ist kürzer als {0} Sekunden: Ziehen Sie das Fenster breiter",
    "Человек в кадре": "Person im Bild",
    "Читаем движения": "Bewegungen werden erfasst",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Fremde Fotos ohne Einwilligung und verbotene Inhalte lassen wir nicht zu.",
    "видео {0}": "Video {0}",
    "голос «{0}»": "Stimme „{0}“",
    "голос «{0}», формат тот же": "Stimme „{0}“, gleiches Format",
    "до": "bis",
    "звук и формат те же": "gleicher Ton und gleiches Format",
    "звук как в видео": "Ton wie im Video",
    "из видео": "aus dem Video",
    "из длинного выберете {0} секунд": "aus einem längeren wählen Sie {0} Sekunden",
    "из этого видео": "aus diesem Video",
    "не повторит движения: нужен человек": "kann die Bewegungen nicht nachahmen: ein Mensch ist nötig",
    "фон с героя": "Hintergrund von der Figur",
    "формат тот же": "gleiches Format"
  },
  "fr": {
    "C в минуту": "C par minute",
    "MP4 или MOV": "MP4 ou MOV",
    "{0} повторил движения из видео, {1}.": "{0} a reproduit les mouvements de la vidéo, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} a reproduit les mouvements de la vidéo, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} est maintenant dans votre vidéo : les mouvements et les expressions sont les vôtres, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} est maintenant dans votre vidéo : les mouvements et les expressions sont les vôtres.",
    "Бот уже прислал видео в чат, в отдельную тему.": "Le bot a déjà envoyé la vidéo dans le chat, dans un sujet à part.",
    "В видео не видно человека": "Aucune personne n’est visible dans la vidéo",
    "В видео нет звука: менять голос нечего": "La vidéo n’a pas de son : aucune voix à changer",
    "Видео и фото проверены": "Vidéo et photo vérifiées",
    "Видео или фото не прошли проверку": "La vidéo ou la photo n’a pas passé la vérification",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "La vidéo dure moins de {0} secondes : il faut de {0} à {1} secondes",
    "Видео короче нужного, загрузите другое": "La vidéo est trop courte, importez-en une autre",
    "Вы повторили движения из видео, {0}.": "Vous avez reproduit les mouvements de la vidéo, {0}.",
    "Выберите фрагмент от 3 секунд": "Choisissez un extrait d’au moins 3 secondes",
    "Выберите, кем стать": "Choisissez qui devenir",
    "Выберите, кто повторит": "Choisissez qui reproduira les mouvements",
    "Герой": "Le personnage",
    "Голос героя": "Voix du personnage",
    "Двигайте фото: в кадре лицо и тело": "Déplacez la photo : le visage et le corps dans le cadre",
    "Движения перенесены": "Mouvements transférés",
    "Движения прочитаны": "Mouvements analysés",
    "Добавьте свои фото или выберите вариант": "Ajoutez vos photos ou choisissez une variante",
    "Добавьте фото того, кто повторит": "Ajoutez une photo de la personne qui reproduira les mouvements",
    "Другое фото": "Autre photo",
    "Загрузите видео с собой": "Importez une vidéo de vous",
    "Загрузите фото того, кто повторит": "Importez une photo de la personne qui reproduira les mouvements",
    "Закончите кадр фото": "Terminez le cadrage de la photo",
    "Заменить видео или фото": "Remplacer la vidéo ou la photo",
    "Кем вы станете в видео": "Qui vous deviendrez dans la vidéo",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "La vidéo circulaire de cette vidéo n’est pas encore disponible : le résultat n’a pas de piste audio confirmée.",
    "Можно своё фото: только своё или с согласием человека на нём": "Vous pouvez utiliser une photo : uniquement la vôtre ou avec le consentement de la personne photographiée",
    "Нажмите на фото ещё раз: кадр или другое фото": "Touchez à nouveau la photo : cadrage ou autre photo",
    "Не нашли человека: нужен один человек в полный рост": "Aucune personne trouvée : il faut une personne en pied",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Aucune personne trouvée : il faut une personne en plan taille ou en pied",
    "Нужно фото: {0}": "Une photo est requise : {0}",
    "Осталось выбрать, кем стать": "Il reste à choisir qui devenir",
    "Осталось выбрать, кто повторит": "Il reste à choisir qui reproduira les mouvements",
    "Осталось добавить фото: {0}": "Il reste à ajouter des photos : {0}",
    "Переносим движения": "Transfert des mouvements",
    "По пояс или в полный рост, от {0} до {1} секунд": "En plan taille ou en pied, de {0} à {1} secondes",
    "Права и согласие": "Droits et consentement",
    "Проверяем видео и фото": "Vérification de la vidéo et de la photo",
    "Смотреть": "Regarder",
    "Смотреть видео с движениями": "Regarder la vidéo des mouvements",
    "Сначала выберите, кто повторит": "Choisissez d’abord qui reproduira les mouvements",
    "Снимите движения: один человек в полный рост": "Filmez les mouvements : une personne en pied",
    "Снимите себя по пояс или в полный рост": "Filmez-vous en plan taille ou en pied",
    "Создать · {0} C": "Créer · {0} C",
    "Создать · от {0} C": "Créer · dès {0} C",
    "Сцена вашего видео, герой встанет на место человека": "La scène de votre vidéo, le personnage prend la place de la personne",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Une danse ou une tendance, une personne en pied, de {0} à {1} secondes",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "« Vous » n’a pas de voix propre : clonez-la dans la section « Clone » ou choisissez-en une autre",
    "У героя нет своего голоса": "Le personnage n’a pas de voix propre",
    "У человека с фото нет своего голоса: выберите другой голос": "La personne de la photo n’a pas de voix propre : choisissez une autre voix",
    "Удалить из видео": "Retirer de la vidéo",
    "Файл слишком большой. Максимум {0} МБ": "Le fichier est trop volumineux. Maximum {0} Mo",
    "Фон с вашего фото": "Arrière-plan de votre photo",
    "Фон с картинки персонажа": "Arrière-plan de l’image du personnage",
    "Фон с фото близкого": "Arrière-plan de la photo du proche",
    "Фон со снимка героя": "Arrière-plan de l’image du personnage",
    "Фрагмент короче {0} секунд: растяните окно": "L’extrait dure moins de {0} secondes : élargissez la fenêtre",
    "Человек в кадре": "Personne dans le cadre",
    "Читаем движения": "Analyse des mouvements",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Nous n’acceptons ni les photos d’autrui sans consentement ni les contenus interdits.",
    "видео {0}": "vidéo {0}",
    "голос «{0}»": "voix « {0} »",
    "голос «{0}», формат тот же": "voix « {0} », même format",
    "до": "jusqu’à",
    "звук и формат те же": "même son et même format",
    "звук как в видео": "son comme dans la vidéo",
    "из видео": "de la vidéo",
    "из длинного выберете {0} секунд": "dans une plus longue, vous choisirez {0} secondes",
    "из этого видео": "de cette vidéo",
    "не повторит движения: нужен человек": "ne peut pas reproduire les mouvements : il faut une personne",
    "фон с героя": "arrière-plan du personnage",
    "формат тот же": "même format"
  },
  "pt": {
    "C в минуту": "C por minuto",
    "MP4 или MOV": "MP4 ou MOV",
    "{0} повторил движения из видео, {1}.": "{0} repetiu os movimentos do vídeo, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} repetiu os movimentos do vídeo, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} agora está no seu vídeo: os movimentos e as expressões são seus, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} agora está no seu vídeo: os movimentos e as expressões são seus.",
    "Бот уже прислал видео в чат, в отдельную тему.": "O bot já enviou o vídeo para o chat, em um tópico separado.",
    "В видео не видно человека": "Não aparece nenhuma pessoa no vídeo",
    "В видео нет звука: менять голос нечего": "O vídeo não tem som: não há voz para trocar",
    "Видео и фото проверены": "Vídeo e foto verificados",
    "Видео или фото не прошли проверку": "O vídeo ou a foto não passaram na verificação",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "O vídeo tem menos de {0} segundos: precisa ter de {0} a {1} segundos",
    "Видео короче нужного, загрузите другое": "O vídeo é curto demais, envie outro",
    "Вы повторили движения из видео, {0}.": "Você repetiu os movimentos do vídeo, {0}.",
    "Выберите фрагмент от 3 секунд": "Escolha um trecho de pelo menos 3 segundos",
    "Выберите, кем стать": "Escolha em quem se transformar",
    "Выберите, кто повторит": "Escolha quem vai repetir",
    "Герой": "O personagem",
    "Голос героя": "Voz do personagem",
    "Двигайте фото: в кадре лицо и тело": "Mova a foto: rosto e corpo no enquadramento",
    "Движения перенесены": "Movimentos transferidos",
    "Движения прочитаны": "Movimentos lidos",
    "Добавьте свои фото или выберите вариант": "Adicione suas fotos ou escolha uma variante",
    "Добавьте фото того, кто повторит": "Adicione uma foto de quem vai repetir",
    "Другое фото": "Outra foto",
    "Загрузите видео с собой": "Envie um vídeo com você",
    "Загрузите фото того, кто повторит": "Envie uma foto de quem vai repetir",
    "Закончите кадр фото": "Termine o enquadramento da foto",
    "Заменить видео или фото": "Trocar o vídeo ou a foto",
    "Кем вы станете в видео": "Em quem você vai se transformar no vídeo",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "O vídeo circular deste vídeo ainda não está disponível: o resultado não tem uma faixa de áudio confirmada.",
    "Можно своё фото: только своё или с согласием человека на нём": "Você pode usar uma foto: só sua ou com o consentimento da pessoa fotografada",
    "Нажмите на фото ещё раз: кадр или другое фото": "Toque na foto de novo: enquadramento ou outra foto",
    "Не нашли человека: нужен один человек в полный рост": "Não encontramos ninguém: é preciso uma pessoa de corpo inteiro",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Não encontramos ninguém: é preciso uma pessoa da cintura para cima ou de corpo inteiro",
    "Нужно фото: {0}": "É preciso uma foto: {0}",
    "Осталось выбрать, кем стать": "Falta escolher em quem se transformar",
    "Осталось выбрать, кто повторит": "Falta escolher quem vai repetir",
    "Осталось добавить фото: {0}": "Falta adicionar fotos: {0}",
    "Переносим движения": "Transferindo os movimentos",
    "По пояс или в полный рост, от {0} до {1} секунд": "Da cintura para cima ou de corpo inteiro, de {0} a {1} segundos",
    "Права и согласие": "Direitos e consentimento",
    "Проверяем видео и фото": "Verificando o vídeo e a foto",
    "Смотреть": "Assistir",
    "Смотреть видео с движениями": "Assistir ao vídeo de movimentos",
    "Сначала выберите, кто повторит": "Primeiro escolha quem vai repetir",
    "Снимите движения: один человек в полный рост": "Grave os movimentos: uma pessoa de corpo inteiro",
    "Снимите себя по пояс или в полный рост": "Grave-se da cintura para cima ou de corpo inteiro",
    "Создать · {0} C": "Criar · {0} C",
    "Создать · от {0} C": "Criar · a partir de {0} C",
    "Сцена вашего видео, герой встанет на место человека": "A cena do seu vídeo; o personagem fica no lugar da pessoa",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Uma dança ou trend, uma pessoa de corpo inteiro, de {0} a {1} segundos",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "“Você” não tem voz própria: clone-a na seção “Clone” ou escolha outra",
    "У героя нет своего голоса": "O personagem não tem voz própria",
    "У человека с фото нет своего голоса: выберите другой голос": "A pessoa da foto não tem voz própria: escolha outra voz",
    "Удалить из видео": "Remover do vídeo",
    "Файл слишком большой. Максимум {0} МБ": "O arquivo é grande demais. Máximo de {0} MB",
    "Фон с вашего фото": "Fundo da sua foto",
    "Фон с картинки персонажа": "Fundo da imagem do personagem",
    "Фон с фото близкого": "Fundo da foto da pessoa próxima",
    "Фон со снимка героя": "Fundo da imagem do personagem",
    "Фрагмент короче {0} секунд: растяните окно": "O trecho tem menos de {0} segundos: amplie a janela",
    "Человек в кадре": "Pessoa no enquadramento",
    "Читаем движения": "Lendo os movimentos",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Não aceitamos fotos de outras pessoas sem consentimento nem conteúdo proibido.",
    "видео {0}": "vídeo {0}",
    "голос «{0}»": "voz “{0}”",
    "голос «{0}», формат тот же": "voz “{0}”, mesmo formato",
    "до": "até",
    "звук и формат те же": "mesmo som e formato",
    "звук как в видео": "som como no vídeo",
    "из видео": "do vídeo",
    "из длинного выберете {0} секунд": "de um mais longo você escolhe {0} segundos",
    "из этого видео": "deste vídeo",
    "не повторит движения: нужен человек": "não pode repetir os movimentos: é preciso uma pessoa",
    "фон с героя": "fundo do personagem",
    "формат тот же": "mesmo formato"
  },
  "tr": {
    "C в минуту": "C / dakika",
    "MP4 или MOV": "MP4 veya MOV",
    "{0} повторил движения из видео, {1}.": "{0} videodaki hareketleri tekrarladı, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} videodaki hareketleri tekrarladı, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} artık videonuzda: hareketler ve mimikler sizin, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} artık videonuzda: hareketler ve mimikler sizin.",
    "Бот уже прислал видео в чат, в отдельную тему.": "Bot videoyu sohbete, ayrı bir konuya zaten gönderdi.",
    "В видео не видно человека": "Videoda kimse görünmüyor",
    "В видео нет звука: менять голос нечего": "Videoda ses yok: değiştirilecek bir ses yok",
    "Видео и фото проверены": "Video ve fotoğraf kontrol edildi",
    "Видео или фото не прошли проверку": "Video veya fotoğraf kontrolden geçmedi",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "Video {0} saniyeden kısa: {0} ile {1} saniye arasında olmalı",
    "Видео короче нужного, загрузите другое": "Video çok kısa, başka bir video yükleyin",
    "Вы повторили движения из видео, {0}.": "Videodaki hareketleri tekrarladınız, {0}.",
    "Выберите фрагмент от 3 секунд": "En az 3 saniyelik bir kesit seçin",
    "Выберите, кем стать": "Kime dönüşeceğinizi seçin",
    "Выберите, кто повторит": "Kimin tekrarlayacağını seçin",
    "Герой": "Karakter",
    "Голос героя": "Karakterin sesi",
    "Двигайте фото: в кадре лицо и тело": "Fotoğrafı kaydırın: yüz ve beden karede olsun",
    "Движения перенесены": "Hareketler aktarıldı",
    "Движения прочитаны": "Hareketler okundu",
    "Добавьте свои фото или выберите вариант": "Fotoğraflarınızı ekleyin veya bir varyant seçin",
    "Добавьте фото того, кто повторит": "Tekrarlayacak kişinin fotoğrafını ekleyin",
    "Другое фото": "Başka fotoğraf",
    "Загрузите видео с собой": "Kendinizin olduğu bir video yükleyin",
    "Загрузите фото того, кто повторит": "Tekrarlayacak kişinin fotoğrafını yükleyin",
    "Закончите кадр фото": "Fotoğraf karesini tamamlayın",
    "Заменить видео или фото": "Videoyu veya fotoğrafı değiştir",
    "Кем вы станете в видео": "Videoda kime dönüşeceksiniz",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "Bu videodan daire video henüz kullanılamıyor: sonuçta onaylanmış bir ses parçası yok.",
    "Можно своё фото: только своё или с согласием человека на нём": "Fotoğraf kullanabilirsiniz: yalnızca kendinizinkini veya fotoğraftaki kişinin onayıyla",
    "Нажмите на фото ещё раз: кадр или другое фото": "Fotoğrafa tekrar dokunun: kare veya başka fotoğraf",
    "Не нашли человека: нужен один человек в полный рост": "Kimse bulunamadı: boydan görünen bir kişi gerekli",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Kimse bulunamadı: belden yukarı veya boydan görünen bir kişi gerekli",
    "Нужно фото: {0}": "Bir fotoğraf gerekli: {0}",
    "Осталось выбрать, кем стать": "Geriye kime dönüşeceğinizi seçmek kaldı",
    "Осталось выбрать, кто повторит": "Geriye kimin tekrarlayacağını seçmek kaldı",
    "Осталось добавить фото: {0}": "Geriye fotoğraf eklemek kaldı: {0}",
    "Переносим движения": "Hareketler aktarılıyor",
    "По пояс или в полный рост, от {0} до {1} секунд": "Belden yukarı veya boydan, {0} ile {1} saniye arası",
    "Права и согласие": "Haklar ve onay",
    "Проверяем видео и фото": "Video ve fotoğraf kontrol ediliyor",
    "Смотреть": "İzle",
    "Смотреть видео с движениями": "Hareket videosunu izle",
    "Сначала выберите, кто повторит": "Önce kimin tekrarlayacağını seçin",
    "Снимите движения: один человек в полный рост": "Hareketleri çekin: boydan görünen bir kişi",
    "Снимите себя по пояс или в полный рост": "Kendinizi belden yukarı veya boydan çekin",
    "Создать · {0} C": "Oluştur · {0} C",
    "Создать · от {0} C": "Oluştur · {0} C’den",
    "Сцена вашего видео, герой встанет на место человека": "Videonuzun sahnesi, karakter kişinin yerine geçer",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Dans veya trend, boydan görünen bir kişi, {0} ile {1} saniye arası",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "“Siz” için kendi sesiniz yok: “Klon” bölümünde klonlayın veya başka bir ses seçin",
    "У героя нет своего голоса": "Karakterin kendi sesi yok",
    "У человека с фото нет своего голоса: выберите другой голос": "Fotoğraftaki kişinin kendi sesi yok: başka bir ses seçin",
    "Удалить из видео": "Videodan çıkar",
    "Файл слишком большой. Максимум {0} МБ": "Dosya çok büyük. En fazla {0} MB",
    "Фон с вашего фото": "Fotoğrafınızdaki arka plan",
    "Фон с картинки персонажа": "Karakter görselindeki arka plan",
    "Фон с фото близкого": "Yakınınızın fotoğrafındaki arka plan",
    "Фон со снимка героя": "Karakterin görüntüsündeki arka plan",
    "Фрагмент короче {0} секунд: растяните окно": "Kesit {0} saniyeden kısa: pencereyi genişletin",
    "Человек в кадре": "Kişi karede",
    "Читаем движения": "Hareketler okunuyor",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Başkalarının onaysız fotoğraflarını ve yasaklı içeriği kabul etmiyoruz.",
    "видео {0}": "video {0}",
    "голос «{0}»": "“{0}” sesi",
    "голос «{0}», формат тот же": "“{0}” sesi, biçim aynı",
    "до": "en fazla",
    "звук и формат те же": "ses ve biçim aynı",
    "звук как в видео": "ses videodaki gibi",
    "из видео": "videodan",
    "из длинного выберете {0} секунд": "uzun videodan {0} saniye seçeceksiniz",
    "из этого видео": "bu videodan",
    "не повторит движения: нужен человек": "hareketleri tekrarlayamaz: bir insan gerekli",
    "фон с героя": "arka plan karakterden",
    "формат тот же": "biçim aynı"
  },
  "kk": {
    "C в минуту": "C минутына",
    "MP4 или MOV": "MP4 немесе MOV",
    "{0} повторил движения из видео, {1}.": "{0} видеодағы қимылдарды қайталады, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} видеодағы қимылдарды қайталады, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} енді сіздің видеоңызда: қимылдар мен мимика сіздікі, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} енді сіздің видеоңызда: қимылдар мен мимика сіздікі.",
    "Бот уже прислал видео в чат, в отдельную тему.": "Бот видеоны чатқа, бөлек тақырыпқа жіберіп қойды.",
    "В видео не видно человека": "Видеода адам көрінбейді",
    "В видео нет звука: менять голос нечего": "Видеода дыбыс жоқ: ауыстыратын дауыс жоқ",
    "Видео и фото проверены": "Видео мен фото тексерілді",
    "Видео или фото не прошли проверку": "Видео немесе фото тексеруден өтпеді",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "Видео {0} секундтан қысқа: {0} секундтан {1} секундқа дейін болуы керек",
    "Видео короче нужного, загрузите другое": "Видео тым қысқа, басқасын жүктеңіз",
    "Вы повторили движения из видео, {0}.": "Сіз видеодағы қимылдарды қайталадыңыз, {0}.",
    "Выберите фрагмент от 3 секунд": "Кемінде 3 секундтық үзінді таңдаңыз",
    "Выберите, кем стать": "Кімге айналатыныңызды таңдаңыз",
    "Выберите, кто повторит": "Кім қайталайтынын таңдаңыз",
    "Герой": "Кейіпкер",
    "Голос героя": "Кейіпкердің дауысы",
    "Двигайте фото: в кадре лицо и тело": "Фотоны жылжытыңыз: кадрда бет пен дене болсын",
    "Движения перенесены": "Қимылдар көшірілді",
    "Движения прочитаны": "Қимылдар оқылды",
    "Добавьте свои фото или выберите вариант": "Фотоларыңызды қосыңыз немесе нұсқа таңдаңыз",
    "Добавьте фото того, кто повторит": "Қайталайтын адамның фотосын қосыңыз",
    "Другое фото": "Басқа фото",
    "Загрузите видео с собой": "Өзіңіз түскен видеоны жүктеңіз",
    "Загрузите фото того, кто повторит": "Қайталайтын адамның фотосын жүктеңіз",
    "Закончите кадр фото": "Фото кадрын аяқтаңыз",
    "Заменить видео или фото": "Видеоны немесе фотоны ауыстыру",
    "Кем вы станете в видео": "Видеода кімге айналасыз",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "Осы видеодан дөңгелек видео әлі қолжетімсіз: нәтижеде расталған дыбыс жолы жоқ.",
    "Можно своё фото: только своё или с согласием человека на нём": "Фото қолдануға болады: тек өзіңіздікін немесе ондағы адамның келісімімен",
    "Нажмите на фото ещё раз: кадр или другое фото": "Фотоны қайта басыңыз: кадр немесе басқа фото",
    "Не нашли человека: нужен один человек в полный рост": "Адам табылмады: толық бойымен бір адам керек",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Адам табылмады: белге дейін немесе толық бойымен бір адам керек",
    "Нужно фото: {0}": "Фото қажет: {0}",
    "Осталось выбрать, кем стать": "Кімге айналатыныңызды таңдау қалды",
    "Осталось выбрать, кто повторит": "Кім қайталайтынын таңдау қалды",
    "Осталось добавить фото: {0}": "Фото қосу қалды: {0}",
    "Переносим движения": "Қимылдарды көшіріп жатырмыз",
    "По пояс или в полный рост, от {0} до {1} секунд": "Белге дейін немесе толық бойымен, {0}–{1} секунд",
    "Права и согласие": "Құқықтар мен келісім",
    "Проверяем видео и фото": "Видео мен фотоны тексеріп жатырмыз",
    "Смотреть": "Көру",
    "Смотреть видео с движениями": "Қозғалыс видеосын көру",
    "Сначала выберите, кто повторит": "Алдымен кім қайталайтынын таңдаңыз",
    "Снимите движения: один человек в полный рост": "Қимылдарды түсіріңіз: толық бойымен бір адам",
    "Снимите себя по пояс или в полный рост": "Өзіңізді белге дейін немесе толық бойымен түсіріңіз",
    "Создать · {0} C": "Жасау · {0} C",
    "Создать · от {0} C": "Жасау · {0} C-тан",
    "Сцена вашего видео, герой встанет на место человека": "Видеоңыздың сахнасы, кейіпкер адамның орнына тұрады",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Би немесе тренд, толық бойымен бір адам, {0}–{1} секунд",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "«Сіз» үшін өз дауысыңыз жоқ: оны «Клон» бөлімінде клондаңыз немесе басқасын таңдаңыз",
    "У героя нет своего голоса": "Кейіпкердің өз дауысы жоқ",
    "У человека с фото нет своего голоса: выберите другой голос": "Фотодағы адамның өз дауысы жоқ: басқа дауыс таңдаңыз",
    "Удалить из видео": "Видеодан алып тастау",
    "Файл слишком большой. Максимум {0} МБ": "Файл тым үлкен. Ең көбі {0} МБ",
    "Фон с вашего фото": "Фотоңыздағы фон",
    "Фон с картинки персонажа": "Кейіпкер суретіндегі фон",
    "Фон с фото близкого": "Жақын адамның фотосындағы фон",
    "Фон со снимка героя": "Кейіпкер суретіндегі фон",
    "Фрагмент короче {0} секунд: растяните окно": "Үзінді {0} секундтан қысқа: терезені кеңейтіңіз",
    "Человек в кадре": "Адам кадрда",
    "Читаем движения": "Қимылдарды оқып жатырмыз",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Бөтен адамдардың келісімсіз фотоларын және тыйым салынған мазмұнды өткізбейміз.",
    "видео {0}": "видео {0}",
    "голос «{0}»": "«{0}» дауысы",
    "голос «{0}», формат тот же": "«{0}» дауысы, формат сол күйі",
    "до": "дейін",
    "звук и формат те же": "дыбыс пен формат сол күйі",
    "звук как в видео": "дыбыс видеодағыдай",
    "из видео": "видеодан",
    "из длинного выберете {0} секунд": "ұзын видеодан {0} секунд таңдайсыз",
    "из этого видео": "осы видеодан",
    "не повторит движения: нужен человек": "қимылдарды қайталай алмайды: адам керек",
    "фон с героя": "фон кейіпкерден",
    "формат тот же": "формат сол күйі"
  },
  "uk": {
    "C в минуту": "C за хвилину",
    "MP4 или MOV": "MP4 або MOV",
    "{0} повторил движения из видео, {1}.": "{0} повторив рухи з відео, {1}.",
    "{0} повторила движения из видео, {1}.": "{0} повторила рухи з відео, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0} тепер у вашому відео: рухи й міміка ваші, {1}.",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0} тепер у вашому відео: рухи й міміка ваші.",
    "Бот уже прислал видео в чат, в отдельную тему.": "Бот уже надіслав відео в чат, в окрему тему.",
    "В видео не видно человека": "У відео не видно людини",
    "В видео нет звука: менять голос нечего": "У відео немає звуку: змінювати голос нічого",
    "Видео и фото проверены": "Відео і фото перевірено",
    "Видео или фото не прошли проверку": "Відео або фото не пройшли перевірку",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "Відео коротше за {0} секунд: потрібно від {0} до {1} секунд",
    "Видео короче нужного, загрузите другое": "Відео закоротке, завантажте інше",
    "Вы повторили движения из видео, {0}.": "Ви повторили рухи з відео, {0}.",
    "Выберите фрагмент от 3 секунд": "Виберіть фрагмент від 3 секунд",
    "Выберите, кем стать": "Виберіть, ким стати",
    "Выберите, кто повторит": "Виберіть, хто повторить",
    "Герой": "Герой",
    "Голос героя": "Голос героя",
    "Двигайте фото: в кадре лицо и тело": "Рухайте фото: у кадрі обличчя й тіло",
    "Движения перенесены": "Рухи перенесено",
    "Движения прочитаны": "Рухи прочитано",
    "Добавьте свои фото или выберите вариант": "Додайте свої фото або виберіть варіант",
    "Добавьте фото того, кто повторит": "Додайте фото того, хто повторить",
    "Другое фото": "Інше фото",
    "Загрузите видео с собой": "Завантажте відео з собою",
    "Загрузите фото того, кто повторит": "Завантажте фото того, хто повторить",
    "Закончите кадр фото": "Завершіть кадр фото",
    "Заменить видео или фото": "Замінити відео або фото",
    "Кем вы станете в видео": "Ким ви станете у відео",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "Кружечок із цього відео поки недоступний: у результаті немає підтвердженої звукової доріжки.",
    "Можно своё фото: только своё или с согласием человека на нём": "Можна своє фото: лише своє або за згодою людини на ньому",
    "Нажмите на фото ещё раз: кадр или другое фото": "Натисніть на фото ще раз: кадр або інше фото",
    "Не нашли человека: нужен один человек в полный рост": "Людину не знайдено: потрібна одна людина на повний зріст",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "Людину не знайдено: потрібна одна людина по пояс або на повний зріст",
    "Нужно фото: {0}": "Потрібне фото: {0}",
    "Осталось выбрать, кем стать": "Залишилося вибрати, ким стати",
    "Осталось выбрать, кто повторит": "Залишилося вибрати, хто повторить",
    "Осталось добавить фото: {0}": "Залишилося додати фото: {0}",
    "Переносим движения": "Переносимо рухи",
    "По пояс или в полный рост, от {0} до {1} секунд": "По пояс або на повний зріст, від {0} до {1} секунд",
    "Права и согласие": "Права і згода",
    "Проверяем видео и фото": "Перевіряємо відео і фото",
    "Смотреть": "Дивитися",
    "Смотреть видео с движениями": "Дивитися відео з рухами",
    "Сначала выберите, кто повторит": "Спершу виберіть, хто повторить",
    "Снимите движения: один человек в полный рост": "Зніміть рухи: одна людина на повний зріст",
    "Снимите себя по пояс или в полный рост": "Зніміть себе по пояс або на повний зріст",
    "Создать · {0} C": "Створити · {0} C",
    "Создать · от {0} C": "Створити · від {0} C",
    "Сцена вашего видео, герой встанет на место человека": "Сцена вашого відео, герой стане на місце людини",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "Танець або тренд, одна людина на повний зріст, від {0} до {1} секунд",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "«Ви» не має власного голосу: клонуйте його в розділі «Клон» або виберіть інший",
    "У героя нет своего голоса": "У героя немає власного голосу",
    "У человека с фото нет своего голоса: выберите другой голос": "У людини з фото немає власного голосу: виберіть інший голос",
    "Удалить из видео": "Прибрати з відео",
    "Файл слишком большой. Максимум {0} МБ": "Файл завеликий. Максимум {0} МБ",
    "Фон с вашего фото": "Фон із вашого фото",
    "Фон с картинки персонажа": "Фон із картинки персонажа",
    "Фон с фото близкого": "Фон із фото близької людини",
    "Фон со снимка героя": "Фон зі знімка героя",
    "Фрагмент короче {0} секунд: растяните окно": "Фрагмент коротший за {0} секунд: розтягніть вікно",
    "Человек в кадре": "Людина в кадрі",
    "Читаем движения": "Читаємо рухи",
    "Чужие фото без согласия и запрещённое не пропускаем.": "Чужі фото без згоди та заборонене не пропускаємо.",
    "видео {0}": "відео {0}",
    "голос «{0}»": "голос «{0}»",
    "голос «{0}», формат тот же": "голос «{0}», формат той самий",
    "до": "до",
    "звук и формат те же": "звук і формат ті самі",
    "звук как в видео": "звук як у відео",
    "из видео": "з відео",
    "из длинного выберете {0} секунд": "з довгого виберете {0} секунд",
    "из этого видео": "з цього відео",
    "не повторит движения: нужен человек": "не повторить рухи: потрібна людина",
    "фон с героя": "фон із героя",
    "формат тот же": "формат той самий"
  },
  "zh": {
    "C в минуту": "C / 分钟",
    "MP4 или MOV": "MP4 或 MOV",
    "{0} повторил движения из видео, {1}.": "{0}模仿了视频中的动作，{1}。",
    "{0} повторила движения из видео, {1}.": "{0}模仿了视频中的动作，{1}。",
    "{0} теперь в вашем видео: движения и мимика ваши, {1}.": "{0}现在出现在你的视频中：动作和表情都是你的，{1}。",
    "{0} теперь в вашем видео: движения и мимика ваши.": "{0}现在出现在你的视频中：动作和表情都是你的。",
    "Бот уже прислал видео в чат, в отдельную тему.": "机器人已把视频发到聊天的单独话题中。",
    "В видео не видно человека": "视频中看不到人",
    "В видео нет звука: менять голос нечего": "视频没有声音：没有可更换的声音",
    "Видео и фото проверены": "视频和照片已检查",
    "Видео или фото не прошли проверку": "视频或照片未通过审核",
    "Видео короче {0} секунд: нужно от {0} до {1} секунд": "视频短于 {0} 秒：时长需在 {0} 到 {1} 秒之间",
    "Видео короче нужного, загрузите другое": "视频太短，请上传其他视频",
    "Вы повторили движения из видео, {0}.": "你模仿了视频中的动作，{0}。",
    "Выберите фрагмент от 3 секунд": "请选择至少 3 秒的片段",
    "Выберите, кем стать": "选择要变成谁",
    "Выберите, кто повторит": "选择由谁来模仿",
    "Герой": "角色",
    "Голос героя": "角色的声音",
    "Двигайте фото: в кадре лицо и тело": "移动照片：让脸和身体都在画面中",
    "Движения перенесены": "动作已迁移",
    "Движения прочитаны": "动作已识别",
    "Добавьте свои фото или выберите вариант": "添加你的照片或选择一个版本",
    "Добавьте фото того, кто повторит": "添加模仿者的照片",
    "Другое фото": "换一张照片",
    "Загрузите видео с собой": "上传你出镜的视频",
    "Загрузите фото того, кто повторит": "上传模仿者的照片",
    "Закончите кадр фото": "完成照片取景",
    "Заменить видео или фото": "替换视频或照片",
    "Кем вы станете в видео": "你在视频中会变成谁",
    "Кружок из этого видео пока недоступен: в результате нет подтверждённой звуковой дорожки.": "此视频暂时无法制作圆形视频：结果中没有已确认的音轨。",
    "Можно своё фото: только своё или с согласием человека на нём": "可以用自己的照片：只能是你本人，或已获得照片中人同意",
    "Нажмите на фото ещё раз: кадр или другое фото": "再次点击照片：调整取景或换一张",
    "Не нашли человека: нужен один человек в полный рост": "未找到人物：需要一个人的全身照",
    "Не нашли человека: нужен один человек по пояс или в полный рост": "未找到人物：需要一个人的半身或全身照",
    "Нужно фото: {0}": "需要照片：{0}",
    "Осталось выбрать, кем стать": "最后选择要变成谁",
    "Осталось выбрать, кто повторит": "最后选择由谁来模仿",
    "Осталось добавить фото: {0}": "最后添加照片：{0}",
    "Переносим движения": "正在迁移动作",
    "По пояс или в полный рост, от {0} до {1} секунд": "半身或全身，{0} 到 {1} 秒",
    "Права и согласие": "版权与同意",
    "Проверяем видео и фото": "正在检查视频和照片",
    "Смотреть": "观看",
    "Смотреть видео с движениями": "观看动作视频",
    "Сначала выберите, кто повторит": "请先选择由谁来模仿",
    "Снимите движения: один человек в полный рост": "拍摄动作：一个人，全身入镜",
    "Снимите себя по пояс или в полный рост": "拍摄自己的半身或全身",
    "Создать · {0} C": "创建 · {0} C",
    "Создать · от {0} C": "创建 · {0} C 起",
    "Сцена вашего видео, герой встанет на место человека": "使用你视频中的场景，角色会替换画面中的人",
    "Танец или тренд, один человек в полный рост, от {0} до {1} секунд": "舞蹈或热门挑战，一个人全身入镜，{0} 到 {1} 秒",
    "У «Вы» нет своего голоса: клонируйте его в разделе «Клон» или выберите другой": "「你」还没有自己的声音：可在「声音克隆」板块克隆，或选择其他声音",
    "У героя нет своего голоса": "该角色没有自己的声音",
    "У человека с фото нет своего голоса: выберите другой голос": "照片中的人没有自己的声音：请选择其他声音",
    "Удалить из видео": "从视频中移除",
    "Файл слишком большой. Максимум {0} МБ": "文件太大。最大 {0} MB",
    "Фон с вашего фото": "背景取自你的照片",
    "Фон с картинки персонажа": "背景取自角色图片",
    "Фон с фото близкого": "背景取自亲友的照片",
    "Фон со снимка героя": "背景取自角色图像",
    "Фрагмент короче {0} секунд: растяните окно": "片段短于 {0} 秒：请拉宽窗口",
    "Человек в кадре": "画面中的人物",
    "Читаем движения": "正在识别动作",
    "Чужие фото без согласия и запрещённое не пропускаем.": "不接受未经同意的他人照片和违禁内容。",
    "видео {0}": "视频 {0}",
    "голос «{0}»": "声音「{0}」",
    "голос «{0}», формат тот же": "声音「{0}」，格式不变",
    "до": "最长",
    "звук и формат те же": "声音和格式不变",
    "звук как в видео": "声音与视频一致",
    "из видео": "来自视频",
    "из длинного выберете {0} секунд": "较长的视频可从中选取 {0} 秒",
    "из этого видео": "来自此视频",
    "не повторит движения: нужен человек": "无法模仿动作：需要真人",
    "фон с героя": "背景取自角色",
    "формат тот же": "格式不变"
  }
}
